import React, { Component } from 'react';

import Loading from '../components/Loading'

class VisitedSpotDetail extends Component {
  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      selectedSpot: null
    }
  }

  componentDidMount() {
    let {spotList} = this.props
    let {id} = this.props.match.params
    if (spotList) {
      for (let i=0; i < spotList.length; i++) {
        if (id === spotList[i].name) {
          this.setState({ selectedSpot: spotList[i] })
        }
      }
    }
  }

  render() {
    let {selectedSpot} = this.state
    if (selectedSpot) {
      return (
        <div className="VisitedSpotDetail">
          <div className="VisitedSpotDetail-name">{selectedSpot.name}</div>
          <img src={selectedSpot.image} alt=''/>
          <div className="VisitedSpotDetail-desc">{selectedSpot.description}</div>
        </div>
      );
    } else {
      return (
        <div className="VisitedSpotDetail">
          <Loading />
        </div>
      )
    }

  }
}

export default VisitedSpotDetail;
